export const FETCH_MAINTENANCE_TYPES = '@@maintenance/fetch-maintenance-types';
export const FETCH_MAINTENANCE_TYPES_SUCCESS = '@@maintenance/fetch-maintenance-types-success';
export const FETCH_MAINTENANCE_TYPES_FAILURE = '@@maintenance/fetch-maintenance-types-failure';
